export default "__VITE_ASSET__CdPnjcEp__"